import { createSelector } from 'reselect';
import type { SortDirection } from '@atlassian/jira-common-constants/src/sort-directions.tsx';
import type { Project } from '@atlassian/jira-common-directory-v2/src/model/shareable-entities/index.tsx';
import type { User } from '@atlassian/jira-user-picker/src/model/index.tsx';
import type { Filter, Query } from '../../../model/index.tsx';
import type { SortField } from '../../../model/sort-field.tsx';
import type { State } from '../../types.tsx';

export const getQuery = (state: State): Partial<Query> => state.query;

export const getSortField = (state: State): SortField => state.query.sortField;
export const getSortDirection = (state: State): SortDirection => state.query.sortDirection;
export const getPage = (state: State): number => state.query.page;

export const getFilter = (state: State): Filter => {
	// in our case, we **know** that there is always a filter
	if (!state.query.filter) {
		throw new Error('Invalid state.');
	}
	return state.query.filter;
};
export const getSearchText = (state: State): string => getFilter(state).text || '';
export const getSelectedProject = (state: State): Project | undefined => getFilter(state).project;
export const getSelectedUser = (state: State): User | undefined => getFilter(state).user;
export const getLoggedInUserAccountId = (state: State): string | null => state.app.props.accountId;

export const isFilterApplied = createSelector(
	getSearchText,
	getSelectedProject,
	getSelectedUser,
	(textValue, projectValue, user) => !!textValue || !!projectValue || !!user,
);
